import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplate} from '../../domain/workout-template';
import type {WorkoutTemplateId} from '../../domain/workout-template-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type DuplicateWorkoutTemplateInput = {
  readonly templateId: WorkoutTemplateId;
};

export class DuplicateWorkoutTemplate
  implements UseCase<[DuplicateWorkoutTemplateInput], WorkoutTemplate>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: DuplicateWorkoutTemplateInput,
  ): Promise<Result<WorkoutTemplate, WorkoutError>> {
    return this.repository.duplicateTemplate(input.templateId);
  }
}
